import { BasePageTrackingService } from '../BasePageTrackingService';

export class PlanningTrackingService extends BasePageTrackingService {
    protected getDefaultPage(): string {
        return this.pathSegments[0];
    }
}
